import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { PreferencesProvider, usePreferences } from './contexts/PreferencesContext.tsx'
import { I18nProvider } from './i18n'

function AppWithI18n() {
  const { preferences } = usePreferences();
  const language = preferences.language || 'en';
  return (
    <I18nProvider language={language}>
      <App />
    </I18nProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PreferencesProvider>
      <AppWithI18n />
    </PreferencesProvider>
  </React.StrictMode>,
)
